import React from 'react';

import { LoadingHeader } from '@lumapps/header/components/LoadingHeader';

const Loading = () => <LoadingHeader />;

export default Loading;
